<template>
  <div class="container SupplierDataEdit">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('settlementUnit.SupplierDataInfo')" name="1">
        <div class="searchBox_top">
          <el-button class="btn" size="mini" type="primary" v-show="auditStatus == 'appr_pass' && emplFlag == 'MDM'" @click="sendToMDM" v-acl="SendUnitOfAccountToMDM">{{ $t('settlementUnit.sendToMDM') }}</el-button>
          <el-button class="btn" size="mini" type="primary" @click="historyBack">{{ $t('common.close') }}</el-button>
        </div>
        <el-card class="box-card">
          <!--供应商主数据维护-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.dataInfo') }}</span>
          </div>
          <el-form :model="unitOfAccountForm" ref="unitOfAccountForm" label-width="160px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="groupSupplierCode" v-if="emplFlag == 'SUP'">
                  <!--供应商邀请码-->
                  <el-input v-model.trim="unitOfAccountForm.groupSupplierCode" clearable maxlength="20" disabled>
                  </el-input>
                </el-form-item>
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="groupSupplierCode" v-else>
                  <!--供应商邀请码-->
                  <el-input v-model.trim="unitOfAccountForm.groupSupplierCode" clearable maxlength="20" disabled>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.supplierType')" prop="groupType">
                  <!--供应商类型-->
                  <ic-select table="TM_SUPPLIER" field="GROUP_TYPE" v-model="unitOfAccountForm.groupType" clearable disabled></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="nameShort">
                  <!--供应商简称-->
                  <el-input v-model.trim="unitOfAccountForm.nameShort" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.supplierNameCn')" prop="nameCn">
                  <!--供应商中文名称-->
                  <el-input v-model="unitOfAccountForm.nameCn" maxlength="20" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.suppliernameEn')" prop="nameEn">
                  <!--供应商英文名称-->
                  <el-input v-model="unitOfAccountForm.nameEn" maxlength="100" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <!-- 结算单位编码 -->
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.queryConditionSupplierCode')" prop="code">
                  <el-input v-model.trim="unitOfAccountForm.code" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="GLN" prop="gln">
                  <el-input v-model="unitOfAccountForm.gln" maxlength="13" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <!--审核状态-->
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.auditStatus')" prop="auditStatus">
                  <ic-select clearable table="TM_UNIT_OF_ACCOUNT" field="STATUS" v-model="unitOfAccountForm.auditStatus" disabled></ic-select>
                </el-form-item>
              </el-col>
              <!-- 社会统一信息代码 -->
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.socialUniformCreditCode')" prop="socialUniformCreditCode">
                  <el-input v-model="unitOfAccountForm.socialUniformCreditCode" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if='emplFlag == "MDM"'>
                <el-form-item :label="$t('settlementUnit.department')" prop="department">
                  <!--部门 MDM可看-->
                  <ic-select clearable table="TM_SUPPLIER" field="DEPARTMENT" v-model="unitOfAccountForm.department" disabled></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if='emplFlag == "MDM"'>
                <el-form-item :label="$t('common.status')" prop="status">
                  <!--启用禁用 MDM可看-->
                  <el-select v-model="unitOfAccountForm.status" :placeholder="$t('common.sel')" disabled>
                    <el-option :label="$t('base.common.statusAble')" value="1"></el-option>
                    <el-option :label="$t('base.common.statusDisable')" value="0"></el-option>
                    <el-option label="已淘汰" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--选择审批人-->
                <el-form-item :label="$t('settlementUnit.SubmitBy')" prop="ssCategoryLeaderId">
                  <el-select v-model="unitOfAccountForm.ssCategoryLeaderId" disabled>
                    <el-option :key="index" v-for="( item, index ) in  SubmitBySSList " :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card class="box-card">
          <!--供应商联系人-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.contacts') }}</span>
          </div>
          <el-form :model="formlinkUsers" ref="formlinkUsers">
            <el-table :data="formlinkUsers.linkUsersList" ref="linkUsersList" border highlight-current-row max-height='420'>
              <el-table-column show-overflow-tooltip prop="name" :label="$t('settlementUnit.contacts')" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="title" :label="$t('supplierManage.position')" min-width="120"></el-table-column>
            </el-table>
          </el-form>
        </el-card>
        <el-card class="box-card">
          <!--供应商地址信息-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.addressInformation') }}</span>
            <span class="addressInformationTip">{{ $t('settlementUnit.addressInformationTip') }}</span>
          </div>
          <el-form :model="formAddress" ref="formAddress">
            <el-table :data="formAddress.plantList" ref="plantList" border highlight-current-row max-height='420'>
              <el-table-column prop="tmSupplierId" type="selection" min-width="55" :selectable="(row, index) => index != 0" />
              <el-table-column show-overflow-tooltip prop="nameCn" :label="$t('sys.roleList.roleCN')" min-width="120"> </el-table-column>
              <el-table-column show-overflow-tooltip prop="nameEn" :label="$t('sys.roleList.roleEN')" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop='plantType' :label="$t('settlementUnit.addressType')" min-width="120">
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.plantType'">
                    <el-select v-model="scope.row.plantType" disabled>
                      <el-option key="REG" :label="$t('settlementUnit.cra')" value="REG"></el-option>
                      <el-option key="PLANT" :label="$t('settlementUnit.factoryAddress')" value="PLANT"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop='plantCode' :label="$t('settlementUnit.code')" min-width="80" v-if="emplFlag == 'MDM'"></el-table-column>
              <el-table-column show-overflow-tooltip prop="areaId" :label="$t('supplierManage.area')" min-width="160">
                <template slot-scope="scope">
                  <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-if="scope.row.areaId">{{scope.row.countryName }}{{ scope.row.provinceName }}{{ scope.row.cityName }}{{ scope.row.areaName}}</el-link>
                  <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-else>{{scope.row.countryTxt }}{{ scope.row.provinceTxt }}{{ scope.row.cityTxt }}{{ scope.row.districtTxt}}</el-link>
                  <!--区域-->
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="address" :label="$t('settlementUnit.detailAddress')" min-width="140"></el-table-column>
              <el-table-column show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')" min-width="120">
                <!-- 联系人 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')}}:{{item.name }},{{ $t('settlementUnit.telephone') }}:{{ item.tel }}，{{ $t('settlementUnit.email')}}:{{ item.email }}<br /></span>
                    </div>
                    <span>{{scope.row.users[0].name}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="100">
                <!-- 联系电话 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')}}:{{item.name }},{{ $t('settlementUnit.telephone') }}:{{ item.tel }}，{{ $t('settlementUnit.email')}}:{{ item.email }}<br /></span>
                    </div>
                    <span>{{scope.row.users[0].tel}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="100">
                <!-- 联系电话 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')}}:{{item.name }},{{ $t('settlementUnit.telephone') }}:{{ item.tel }}，{{ $t('settlementUnit.email')}}:{{ item.email }}，办公室电话 ：{{ item.officeTel }}<br /></span>
                    </div>
                    <span>{{ scope.row.users[0].officeTel}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')" min-width="120">
                <!-- 邮箱 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')}}:{{item.name }},{{ $t('settlementUnit.telephone') }}:{{ item.tel }}，{{ $t('settlementUnit.email')}}:{{ item.email }}<br /></span>
                    </div>
                    <span>{{scope.row.users[0].email}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="postCode" :label="$t('settlementUnit.Postcode')" min-width="120"></el-table-column>
              <el-table-column show-overflow-tooltip :label="$t('settlementUnit.qualificationFile')" min-width="80">
                <!-- 资质文件 -->
                <template slot-scope="scope">
                  <i class="el-icon-folder-checked iconUploadSuccess" v-if="scope.row.existsFile == 'Y'"></i>
                  <el-link type="primary" @click="seeQualificationFile(scope.row, scope.$index)">{{ $t('common.upload')}}</el-link>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop='status' :label="$t('settlementUnit.status')" min-width="120">
                <!-- 启用禁用 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.status'" v-if="scope.$index != 0">
                    <!-- MDM 审批通过 的时候 要可以改 -->
                    <el-select v-model="scope.row.status" disabled>
                      <el-option key="0" :label="$t('settlementUnit.disabled')" value="0"></el-option>
                      <el-option key="1" :label="$t('settlementUnit.enabled')" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('settlementUnit.qualificationFile')" name="2" v-if="id">
        <!--资质文件-->
        <el-table :data="LegalFileList" border highlight-current-row max-height='500'>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.qualificationDocuments')" prop='title'></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.template')" prop='templateName'>
            <!--范本-->
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadTemplate(scope.row.template, scope.row.templateName)">{{scope.row.templateName }}
              </el-link>
              <el-link type="primary" @click.native="downloadTemplate(scope.row.template2, scope.row.templateName2)">{{scope.row.templateName2 }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.historicalFileVersion')" prop='historyFile'>
            <!--历史文件版本-->
            <template scope="scope">
              <el-link style="display:block" type="primary" v-for='( v, index ) in  scope.row.historyFile ' :key="index" @click.native="downloadhistoryFile(v)">{{ v.documentName }} </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.currentVersionFile')" prop='currentName'>
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadLegalFile(scope.row)">{{ scope.row.currentName }} </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.status')" prop='status' :formatter="formatStatus" width="160" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.operation')" width="200">
            <template slot-scope="scope">
              <div class="operationBox">
                <div v-if="scope.$index == 3" style="margin-left:10px">
                  <el-button type="primary" size='mini' @click="toEngagementDetail">{{ $t('common.see') }}</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="3" v-if="id">
        <!--审批日志-->
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')">
            <template slot-scope="scope">{{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss") }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion')"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="AreaDialog" width="400px">
      <!--区域弹框-->
      <el-form :model="AreaForm" ref="AreaForm" label-width="60px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.country')" prop="country">
              <el-select v-model="AreaForm.country" :placeholder="$t('common.sel')" @change="countryChange" disabled>
                <el-option clearable v-for=" item  in  countryList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.province')" prop="province">
              <el-select v-model="AreaForm.province" :placeholder="$t('common.sel')" @change="provinceChange" disabled>
                <el-option clearable v-for=" item  in  provinceList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.city')" prop="city">
              <el-select v-model="AreaForm.city" :placeholder="$t('common.sel')" @change="cityChange" disabled>
                <el-option clearable v-for=" item  in  cityList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.tmAreaId')" prop="tmAreaId">
              <el-select v-model="AreaForm.tmAreaId" :placeholder="$t('common.sel')" @change="AreaChange" disabled>
                <el-option clearable v-for=" item  in  AreaList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="AreaDialog = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="qualificationsDialog" width="50%" :before-close='closeQualificationsDialog'>
      <!--资质文件弹框-->
      <el-table :data="qualificationsList" border highlight-current-row class="table">
        <el-table-column prop="HeaderName" :label="$t('common.file')" max-width="130px"></el-table-column>
        <el-table-column prop="documentName" :label="$t('supplierManage.fileName')">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.tmDocumentId" @click.native="downloadQualifications(scope.row)">{{ scope.row.documentName }} </el-link>
            <span v-else>{{ scope.row.documentName }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="closeQualificationsDialog">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BCApi from "@/api/BC/BC";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import unitApi from "@/api/unit/unit";
import supplierApi from "@/api/supplier/supplier";
export default {
  components: { IcSelect },
  data() {
    return {
      plantCodeForm: {
        plantCode: "",
      },
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      disableAreaInput: '',
      disableAddressUserInput: '',
      currentTab: '1',
      supplierObj: {},
      auditStatus: 'draft',
      unitOfAccountForm: {
        groupType: '',
        tmSupplierId: '',
        tmUnitOfAccountId: '',
        groupSupplierCode: '',
        nameShort: '',
        nameCn: '',
        nameEn: '',
        gln: '',
        department: '',
        bankName: '',
        bankAddress: '',
        accountNo: '',
        shareholdingRatio: '',
        isPayByCredit: '',
        status: '',
        createType: '',
        ssCategoryLeaderId: '',
        ssCategoryLeaderName: '',
      },
      loginSupplierId: '',
      groupName: '',
      formlinkUsers: {
        linkUsersList: [],
      },

      formAddress: {
        plantList: [{ plantType: 'REG', status: '1', existsFile: 'N' }],
      },
      LegalFileList: [
        { formType: 0, title: '保密协议', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件二 麦当劳保密协议_CN.PDF', templateName: '附件二 麦当劳保密协议_CN.PDF', template2: '/templates/download/附件二 麦当劳保密协议_ENCN.PDF', templateName2: '附件二 麦当劳保密协议_ENCN.PDF', },
        { formType: 1, title: '乐信贸易采购协议-非玩具类', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/采购协议延伸库存.pdf', templateName: '采购协议延伸库存.pdf' },
        { formType: 2, title: '乐信贸易采购协议-玩具类', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/采购协议非延伸库存.pdf', templateName: '采购协议非延伸库存.pdf' },
        { title: 'BRA Engagement Form' },
        { formType: 3, title: 'Business Relationship Agreement (业务关系协议）', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '营业执照', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '生产许可证', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '供应商企业基础信息截屏/身份证', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '银行资料\n企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '供应商行为准则 企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件五-1 供应商行为准则_CN.pdf', templateName: '附件五-1 供应商行为准则_CN.pdf', template2: '/templates/download/附件五-1 供应商行为准则_EN.pdf', templateName2: '附件五-1 供应商行为准则_EN.pdf', },
        { title: '利益冲突声明 企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件六 利益冲突声明.docx', templateName: '附件六 利益冲突声明.docx' },
        { title: '礼品和招待', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件五-2 供应商指导原则-礼品和招待_CN.pdf', templateName: '附件五-2 供应商指导原则-礼品和招待_CN.pdf', template2: '/templates/download/附件五-2 供应商指导原则-礼品和招待_EN.pdf', templateName2: '附件五-2 供应商指导原则-礼品和招待_EN.pdf', },
        { title: '第三方新增及修改申请表', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件一 第三方新增及修改申请表.xls', templateName: '附件一 第三方新增及修改申请表.xls' },
        { title: '合规评定', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '国家公信网截屏', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
      ],
      rowIndexLegalFile: '',//法务文件的行index
      rowStatus: '',
      rowIndex: '',
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      AreaDialog: false,
      AreaForm: {
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
      },
      qualificationsDialog: false,
      id: null,
      tmSupplierId: '',
      DestroyIncomeStatistics: "",
      qualificationsList: [{ HeaderName: '营业执照(三合一)' }, { HeaderName: '生产许可证' }, { HeaderName: '经营许可证' }],
      QualificationFileId: '',//上传资质文件用到的id
      canAudit: false,
      auditLog: [],//审批日志
      emplFlag: '',
      SubmitBySSList: [],
      isShow: true,
    }
  },
  created() {
    this.id = this.$route.query.id;
    if (this.$route.query.id) {
      if (this.$route.query.hasHistory) {
        this.hasHistory = this.$route.query.hasHistory
        this.getDetail(this.$route.query.id, this.$route.query.hasHistory)
      } else {
        this.getDetail(this.$route.query.id)
      }
      this.getAccountUnitAddress(this.$route.query.id)
      //获取法务文件 所有（tab页中的）
      this.getLegalFileOther(this.$route.query.id)
      //获取法务文件前四项的status tmLawFileId
      this.getLawFile(this.$route.query.id)
    } else {
    }
    this.getSubmitBySS()
    this.getArea()
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
      this.unitOfAccountForm.groupSupplierCode = JSON.parse(localStorage.getItem("supplierObj")).invitationCode
      this.loginSupplierId = JSON.parse(localStorage.getItem("supplierObj")).tmSupplierId
      this.LegalFileList.pop()
      this.LegalFileList.pop()
      this.LegalFileList.pop()
      this.blurGroupSupplierCode()
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
    this.unitOfAccountForm.createType = this.$route.query.createType;

  },
  mounted() {
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    console.log('dataScope', dataScope);
    if (dataScope) {
      if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  },
  methods: {
    getDetail(id, hasHistory = 'N') {
      let that = this
      unitApi.getDetail(id, hasHistory).then(res => {
        this.unitOfAccountForm = res.data
        if (that.unitOfAccountForm.ssCategoryLeaderId) {
          that.unitOfAccountForm.ssCategoryLeaderId = parseInt(that.unitOfAccountForm.ssCategoryLeaderId)
        }
        let linkUsersList = res.data.users
        if (linkUsersList.length > 0) {
          for (let i = 0, len = linkUsersList.length; i < len; i++) {
            linkUsersList[i].delIds = i;
          }
          this.formlinkUsers.linkUsersList = linkUsersList
        }
        this.canAudit = res.data.canAudit
        this.auditLog = res.data.logs
        this.auditStatus = res.data.auditStatus
      });
    },
    //发送MDM
    sendToMDM() {
      unitApi.sendToMDM(this.unitOfAccountForm.tmUnitOfAccountId).then(res => {
        if (res.code == '200') {
          this.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          this.historyBack()
        }
      });

    },
    getAccountUnitAddress(id) {
      unitApi.getAccountUnitAddress(id).then(res => {
        this.formAddress.plantList = res.data
      });
    },
    getLawFile(id) {
      let that = this
      unitApi.getLawFile(id).then(res => {
        let data = res.data
        data.forEach((item, index) => {
          if (item.formType == '0') {
            that.LegalFileList[0].status = item.status
            if (item.applyNo) {
              that.LegalFileList[0].applyNo = item.applyNo
            }
            that.LegalFileList[0].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 0, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 0);
            }
          }
          if (item.formType == '1') {
            that.LegalFileList[1].status = item.status
            if (item.applyNo) {
              that.LegalFileList[1].applyNo = item.applyNo
            }
            that.LegalFileList[1].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 1, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 1);
            }
          }
          if (item.formType == '2') {
            that.LegalFileList[2].status = item.status
            if (item.applyNo) {
              that.LegalFileList[2].applyNo = item.applyNo
            }
            that.LegalFileList[2].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 2, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 2);
            }
          }
          if (item.formType == '4') {
            that.LegalFileList[4].status = item.status
            if (item.applyNo) {
              that.LegalFileList[4].applyNo = item.applyNo
            }
            that.LegalFileList[4].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 4, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 4);
            }
          }
        })

      });
    },
    //根据邀请码获取供应商
    blurGroupSupplierCode() {
      let that = this
      let loginSupplierId = that.loginSupplierId;
      let code = that.unitOfAccountForm.groupSupplierCode
      that.unitOfAccountForm.ssCategoryLeaderId = ''
      if (!loginSupplierId && !code) {
        that.unitOfAccountForm.groupType = ''
        that.unitOfAccountForm.nameShort = ''
        that.unitOfAccountForm.nameCn = ''
        that.unitOfAccountForm.nameEn = ''
        that.unitOfAccountForm.department = ''
        that.unitOfAccountForm.ssCategoryLeaderId = ''
        return
      }
      if (commonFun.isNotEmpty(this.$route.query.id)) {
        return
      }
      supplierApi.getResourceList({ tmSupplierId: loginSupplierId, invitationCode: code }).then((res) => {
        if (res.resultData.length == 1) {
          if (res.resultData[0].status == '0') {
            that.$message({ message: "供应商已被禁用", type: "warning" });
            return
          }

          that.unitOfAccountForm.groupType = res.resultData[0].groupType
          that.unitOfAccountForm.nameShort = res.resultData[0].supplierNameShort
          that.unitOfAccountForm.nameCn = res.resultData[0].supplierName
          that.groupName = res.resultData[0].supplierName
          that.unitOfAccountForm.nameEn = res.resultData[0].supplierNameEn
          that.unitOfAccountForm.department = res.resultData[0].department
          that.unitOfAccountForm.tmSupplierId = res.resultData[0].tmSupplierId
          that.unitOfAccountForm.groupSupplierCode = res.resultData[0].invitationCode
        } else {
          that.unitOfAccountForm.groupType = ''
          that.unitOfAccountForm.nameShort = ''
          that.unitOfAccountForm.nameCn = ''
          that.unitOfAccountForm.nameEn = ''
          that.unitOfAccountForm.department = ''
          that.unitOfAccountForm.groupSupplierCode = ''
          that.unitOfAccountForm.ssCategoryLeaderId = ''
          that.$message({ message: "未找到对应的供应商邀请码/编码", type: "warning" });
        }
      });
    },
    selectArea(row, index) {
      let that = this
      //取出省市区 带到弹框中
      this.AreaDialog = true
      if (commonFun.isNotEmpty(row.countryId)) {
        that.countryChange(row.countryId)
        that.provinceChange(row.provinceId)
        that.cityChange(row.cityId)
        Promise.all([that.countryChange(), that.provinceChange(), that.cityChange()]).then(() => {
          if (commonFun.isNotEmpty(row.countryId)) {
            that.AreaForm.country = row.countryId
            that.AreaForm.province = row.provinceId
            that.AreaForm.city = row.cityId
            that.AreaForm.tmAreaId = row.areaId
          }
        })
      } else {
        that.AreaForm.country = row.countryTxt
        that.AreaForm.province = row.provinceTxt
        that.AreaForm.city = row.cityTxt
        that.AreaForm.tmAreaId = row.districtTxt
      }

    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    //国家选择之后 获取省份
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.countryList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.countryName = selectedWorkName.name
        }
        that.AreaForm.province = ''
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.provinceList = res.data
          resolve()
        });
      })
    },
    //省份选择之后 获取市
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.provinceList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.provinceName = selectedWorkName.name
        }
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          resolve()
        });
      })

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.cityList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.cityName = selectedWorkName.name
        }
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          resolve()
        });
      })

    },
    //国家省市区全部选完
    AreaChange(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.AreaList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      if (selectedWorkName) {
        that.areaName = selectedWorkName.name
      }
    },
    //查看资质文件
    seeQualificationFile(row, index) {
      let that = this
      let code = that.unitOfAccountForm.groupSupplierCode
      if (!code) {
        that.$message({
          message: '先填写邀请码',
          type: "warning"
        });
        return;
      }
      if (index != 0 && that.unitOfAccountForm.groupType == 'SUPPLIER') {//不是第一行 且 groupType=SUPPLIER 则不可编辑
        this.disableAddressUserInput = true
      } else {
        this.disableAddressUserInput = false
      }
      this.rowIndex = index
      this.QualificationFileId = row.tmSupplierId
      this.qualificationsDialog = true
      let groupType = this.unitOfAccountForm.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
      if (row.tmSupplierId) {//如果有id，获取一下 三种资质文件
        this.getBusinessLicense()
        this.getProductionLicense()
        this.getManagementLicense()
      } else {
        if (that.formAddress.plantList[index].businessCertificateDocument) {
          let obj = Object.assign({}, that.qualificationsList[0], that.formAddress.plantList[index].businessCertificateDocument)
          that.qualificationsList.splice(0, 1, obj);
        }
        if (that.formAddress.plantList[index].productionLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[1], that.formAddress.plantList[index].productionLicenseDocument)
          that.qualificationsList.splice(1, 1, obj);
        }
        if (that.formAddress.plantList[index].businessLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[2], that.formAddress.plantList[index].businessLicenseDocument)
          that.qualificationsList.splice(2, 1, obj);
        }
      }
    },
    //获取资质文件 营业执照
    getBusinessLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_CERTIFICA';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          // 通过splice()方法，删除某个元素后，再添加一个元素，达到“赋值”的效果 否则页面不会从新渲染
          let obj = Object.assign({}, that.qualificationsList[0], fileRes[0])
          that.qualificationsList.splice(0, 1, obj);
        }
      })
    },
    //获取资质文件 生产许可证
    getProductionLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'PRODUCTION_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[1], fileRes[0])
          that.qualificationsList.splice(1, 1, obj);
        }

      })
    },
    //获取资质文件 经营许可证
    getManagementLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[2], fileRes[0])
          that.qualificationsList.splice(2, 1, obj);
        }

      })
    },
    beforeQualifications() {
    },
    getFileIndex(index) {
      let that = this
      switch (index) {
        case 0:
          that.seq = 'BUSINESS_CERTIFICA'
          break;
        case 1:
          that.seq = 'PRODUCTION_LICENSE'
          break;
        case 2:
          that.seq = 'BUSINESS_LICENSE'
          break;
      }
    },
    //上传弹框中的资质文件
    uploadQualifications(item) {
      let that = this;
      let QualificationFileId = this.QualificationFileId
      let seq = that.seq
      if (QualificationFileId) {//先判断有没有id
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          //调用后台方法进行文件关系维护
          let attachment = {};
          attachment.documents = res.data;
          attachment.seq = seq;
          attachment.tsRecId = QualificationFileId;
          attachment.tsReckindId = 'SUPPLIER';
          fileService.saveFile(attachment).then((saveRes) => {
            fileService.getFileList(attachment).then(fileRes => {
              //上传成功后 删除上次上传的
              if (fileRes.length > 1) {
                let tmDocumentId = fileRes[0].tmDocumentId
                fileService.deleteFile(tmDocumentId).then(Delres => {
                  switch (seq) {
                    case 'BUSINESS_CERTIFICA':
                      that.getBusinessLicense()
                      break;
                    case 'PRODUCTION_LICENSE':
                      that.getProductionLicense()
                      break;
                    case 'BUSINESS_LICENSE':
                      that.getManagementLicense()
                      break;
                  }
                });
              } else {
                switch (seq) {
                  case 'BUSINESS_CERTIFICA':
                    that.getBusinessLicense()
                    break;
                  case 'PRODUCTION_LICENSE':
                    that.getProductionLicense()
                    break;
                  case 'BUSINESS_LICENSE':
                    that.getManagementLicense()
                    break;
                }
              }
            });
            that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
          })
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {//没有id无法保存关系
          let documents = res.data[0]
          let obj = {}
          switch (seq) {
            case 'BUSINESS_CERTIFICA':
              obj = Object.assign({}, that.qualificationsList[0], documents)
              that.qualificationsList.splice(0, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessCertificateDocument = documents
              break;
            case 'PRODUCTION_LICENSE':
              obj = Object.assign({}, that.qualificationsList[1], documents)
              that.qualificationsList.splice(1, 1, obj);
              that.formAddress.plantList[that.rowIndex].productionLicenseDocument = documents
              break;
            case 'BUSINESS_LICENSE':
              obj = Object.assign({}, that.qualificationsList[2], documents)
              that.qualificationsList.splice(2, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessLicenseDocument = documents
              break;
          }
          that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      }
    },
    //下载资质文件
    downloadQualifications(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //删除弹框中的资质文件
    delQualificationsr(index, row) {
      let that = this
      console.log(row)
      if (commonFun.isNotEmpty(row.tmDocumentId)) {
        fileService.deleteFile(row.tmDocumentId).then((res) => {
          //删除成功删除列表数据
          that.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          let obj = {}
          switch (index) {
            case 0:
              that.qualificationsList.splice(0, 1, { HeaderName: '营业执照(三合一)' });
              break;
            case 1:
              that.qualificationsList.splice(1, 1, { HeaderName: '生产许可证' });
              break;
            case 2:
              that.qualificationsList.splice(2, 1, { HeaderName: '经营许可证' });
              break;
          }
        })
      } else {//没有当前行id
        let obj = {}
        switch (index) {
          case 0:
            if (that.formAddress.plantList[0].businessCertificateDocument) {
              that.qualificationsList.splice(0, 1, { HeaderName: '营业执照' });
              delete that.formAddress.plantList[0]["businessCertificateDocument"]
            }
            break;
          case 1:
            if (that.formAddress.plantList[0].productionLicenseDocument) {
              that.qualificationsList.splice(1, 1, { HeaderName: '生产许可证' });
              delete that.formAddress.plantList[0]["productionLicenseDocument"]
            }
            break;
          case 2:
            if (that.formAddress.plantList[0].businessLicenseDocument) {
              that.qualificationsList.splice(2, 1, { HeaderName: '经营许可证' });
              delete that.formAddress.plantList[0]["businessLicenseDocument"]
            }
            break;
        }
      }
    },
    //关闭地址中的上传资质文件
    closeQualificationsDialog() {
      let that = this
      this.qualificationsDialog = false
      let groupType = this.unitOfAccountForm.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
    },
    getAddressById(id) {
      let that = this
      let data = {
        pageNum: 1,
        pageSize: 15,
        tmSupplierId: id
      }
      unitApi.getAddress(data, id).then(res => {
        console.log(res)

      });
    },
    getSubmitBySS(type) {
      let data = {
        typeList: ['SS', 'ADMIN', "NFC"]
      }
      BCApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          var hash = {}
          this.SubmitBySSList = res.data.reduce(function (item, next) {
            hash[next.userName] ? '' : hash[next.userName] = true && item.push(next)
            return item
          }, [])
        }
      });
    },
    //初始化页面 获取法务文件tab页面列表
    getLegalFileOther(id, index) {
      if (index) {//有index 是上传之后调用的
        this.getLegalFileByIndex(id, index);
      } else {//没有index初始化页面调用
        this.getLegalFileByIndex(id, 0);
        this.getLegalFileByIndex(id, 1);
        this.getLegalFileByIndex(id, 2);
        // this.getLegalFileByIndex(id,3);
        this.getLegalFileByIndex(id, 4);
        this.getLegalFileByIndex(id, 5);
        this.getLegalFileByIndex(id, 6);
        this.getLegalFileByIndex(id, 7);
        this.getLegalFileByIndex(id, 8);
        this.getLegalFileByIndex(id, 9);
        this.getLegalFileByIndex(id, 10);
        this.getLegalFileByIndex(id, 11);
        this.getLegalFileByIndex(id, 12);
        this.getLegalFileByIndex(id, 13);
        this.getLegalFileByIndex(id, 14);
        // this.getLegalFileByIndex(id,15);
        // this.getLegalFileByIndex(id,16);
      }
    },
    getLegalFileByIndex(id, index) {
      let that = this
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = id;
      attachment.tsReckindId = 'LegalFile' + index;
      fileService.getFileList(attachment).then(fileRes => {
        if (fileRes.length > 0) {
          let newArr = []
          fileRes.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
          // that.LegalFileList[index].historyFile = fileRes
          //历史文件保留4版，不包含最新版
          if (fileRes.length > 4) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            newArr = fileRes.slice(1, 5)
            console.log(newArr)
            that.LegalFileList[index].historyFile = newArr
          }
          if (fileRes.length == 1) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            that.LegalFileList[index].historyFile = []
          }
          if (fileRes.length <= 4 && fileRes.length > 1) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            newArr = fileRes.slice(1, fileRes.length)
            that.LegalFileList[index].historyFile = newArr
          }
          that.$set(that.LegalFileList[index], `currentName`, fileRes[0].documentName)
        }
      });
    },
    getLegalFileByIndexAndLawFileId(id, index, LawFileId) {//合并法务文件详情页上传的
      let that = this
      let arr = []
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = id;
      attachment.tsReckindId = 'LegalFile' + index;
      fileService.getFileList(attachment).then(fileRes => {
        let attachment2 = {};
        attachment2.seq = "1";
        attachment2.tsRecId = LawFileId;
        attachment2.tsReckindId = 'TM_LAW_FIEL_SIGN';
        fileService.getFileList(attachment2).then(fileRes2 => {
          if (fileRes2.length > 0) {
            fileRes2.forEach((value, index) => {
              value['flag'] = 'other'
            })
            arr.push.apply(arr, fileRes2)
          }
          if (fileRes.length > 0) {
            arr.push.apply(arr, fileRes)
          }
          if (arr.length > 4) {
            arr.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
            let newArr = arr.slice(0, 4)
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], newArr[0]);
            that.LegalFileList[index].historyFile = newArr
            that.$set(that.LegalFileList[index], `currentName`, newArr[0].documentName)
          }
          else if (arr.length > 0 && arr.length <= 4) {
            arr.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], arr[0]);
            that.LegalFileList[index].historyFile = arr
            that.$set(that.LegalFileList[index], `currentName`, arr[0].documentName)
          }
        });
      });
    },
    //下载当前版本
    downloadLegalFile: function (row) {
      console.log(row)
      if (row.flag && row.flag == 'other') {
        console.log('法务文件下载')
        fileService.downloadFileLms(row)
      } else {

        fileService.downloadFile(row)
      }
    },
    //下载资质文件中的历史版本
    downloadhistoryFile: function (row) {
      if (row.flag && row.flag == 'other') {
        console.log('法务文件下载')
        fileService.downloadFileLms(row)
      } else {
        fileService.downloadFile(row)
      }
    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    //关闭
    closeSupplierContactsAddress() {
      let that = this
      this.addressAddSupplierContactListDialog = false
      that.$refs.addressAddSupplierContactListForm.clearValidate();
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    //提交的时候校验 资质文件tab页全部上传
    getLegalFileResult(id, index) {
      return new Promise((resolve, reject) => {
        let that = this
        let attachment = {};
        attachment.seq = "1";
        attachment.tsRecId = id;
        attachment.tsReckindId = 'LegalFile' + index;
        fileService.getFileList(attachment).then(fileRes => {
          if (fileRes.length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        });

      });
    },
    //提交的时候校验 资质文件tab页前四项上传
    getLegalFileResult2(id, index, tmLawFileId) {
      return new Promise((resolve, reject) => {
        let that = this
        let attachment = {};
        attachment.seq = "1";
        attachment.tsRecId = id;
        attachment.tsReckindId = 'LegalFile' + index;
        fileService.getFileList(attachment).then(fileRes => {
          if (fileRes.length > 0) {
            resolve(true)
          } else {
            if (tmLawFileId) {
              //获取法务文件那里的
              let attachment2 = {};
              attachment2.seq = "1";
              attachment2.tsRecId = tmLawFileId;
              attachment2.tsReckindId = 'TM_LAW_FIEL_SIGN';
              fileService.getFileList(attachment2).then(fileRes2 => {
                if (fileRes2.length > 0) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              });
            } else {
              resolve(false)
            }
          }
        });

      });
    },
    toEngagementDetail() {
      this.$router.push({
        path: `/EngagementDetail`,
        query: {
          tmSupplierId: this.id, supplierName: this.unitOfAccountForm.nameCn,
          supplierNameEn: this.unitOfAccountForm.nameEn, accountNo: this.unitOfAccountForm.code
        }
      });
    },
    formatStatus: function (row, column) {
      return row.status == "draft"
        ? row.applyNo + " 草稿"
        : row.status == "appr_ss"
          ? row.applyNo + " 待审核"
          : row.status == "appr_lp"
            ? row.applyNo + " 待法务审核"
            : row.status == "appr_pass"
              ? row.applyNo + " 审核通过"
              : row.status == "appr_rej"
                ? row.applyNo + " 退回"
                : row.status == "pigeonhole"
                  ? row.applyNo + " 归档"
                  : " ";
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 10px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.SupplierDataEdit {
  .searchBox_bottom {
    display: flex;

    .el-upload {
      display: block;
    }
  }

  .iconUploadSuccess {
    font-size: 24px;
    color: #f8ab01;
    position: absolute;
    top: 20px;
    right: 6px;
  }

  .operationBox {
    display: flex;

    .el-button--mini,
    .el-button--mini.is-round {
      padding: 9px 15px;
    }
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }

  .plantCodeForm
    .el-form-item.is-required:not(.is-no-asterisk)
    > .el-form-item__label:before {
    content: "*";
  }

  .addressInformationTip {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 5px;
  }
}
</style>

